export const ISCLICKED_TRUE="ISCLICKED_TRUE";
export const ISCLICKED_FALSE="ISCLICKED_FALSE";

export const SHOW_COLOR_IMAGE_TRUE="SHOW_COLOR_IMAGE_TRUE";
export const SHOW_COLOR_IMAGE_FALSE="SHOW_COLOR_IMAGE_FALSE";

export const SET_IMAGE_TRUE="SET_IMAGE_TRUE";
export const SET_IMAGE_FALSE="SET_IMAGE_FALSE";

export const SET_ISPINNED="SET_ISPINNED";

export const SET_BACKGROUND_COLOR="SET_BACKGROOUND_COLOR";
export const RESET_BACKGROUND_COLOR="RESET_BACKGROUND_COLOR";

export const SET_BACKGROUND_IMAGE="SET_BACKGROUND_IMAGE";
export const RESET_BACKGROUND_IMAGE="RESET_BACKGROUND_IMAGE";

export const SET_IMAGE="SET_IMAGE";
export const RESET_IMAGE="RESET_IMAGE";

export const SET_FORM_DATA="SET_FORM_DATA";
export const RESET_FORM_DATA="RESET_FORM_DATA";

export const GET_NOTE_LOADING="GET_NOTE_LOADING";
export const GET_NOTE_SUCCESS="GET_NOTE_SUCCESS";
export const GET_NOTE_ERROR="GET_NOTE_ERROR";

export const POST_NOTE_LOADING="POST_NOTE_LOADING";
export const POST_NOTE_SUCCESS="POST_NOTE_SUCCESS";
export const POST_NOTE_ERROR="POST_NOTE_ERROR";

export const UPDATE_NOTE_LOADING="UPDATE_NOTE_LOADING";
export const UPDATE_NOTE_SUCCESS="UPDATE_NOTE_SUCCESS";
export const UPDATE_NOTE_ERROR="UPDATE_NOTE_ERROR";

export const DELETE_NOTE_LOADING="DELETE_NOTE_LOADING";
export const DELETE_NOTE_SUCCESS="DELETE_NOTE_SUCCESS";
export const DELETE_NOTE_ERROR="DELETE_NOTE_ERROR";

export const INCREMENT_PAGE="INCREMENT_PAGE";
export const DECREMENT_PAGE="DECREMENT_PAGE";

export const POPULATE_FORM_DATA="POPULATE_FORM_DATA";

export const GET_ALL_INPUTS="GET_ALL_INPUTS";
export const RESET_ALL_INPUTS="RESET_ALL_INPUTS"

export const RESET_POST_FLAGS="RESET_POST_FLAGS";
export const RESET_UPDATE_FLAGS="RESET_UPDATE_FLAGS";
export const RESET_DELETE_FLAGS="RESET_DELETE_FLAGS";

